export enum TestIds {
  TAG_NAME_INPUT = 'tag-name-input',
}

export const tagNameMaxLength = 200;

export const ALLOWED_REGEX = /^[a-zA-Z0-9 !@#$%]*$/;
export const FORBIDDEN_REGEX = /[=\-<(:_\\?*;|&+,}/^`[)>'{\]"~.]/;
